import { TABLES } from "../db";
import { BaseLocalRepository } from "./BaseLocalRepository";

export class LocalVesselInstallationRepository extends BaseLocalRepository {
  constructor(db) {
    super(db, TABLES.VESSEL_INSTALLATIONS);
  }

  async getByVesselId(vesselId) {
    return this.table.where("vesselId").equals(vesselId).first();
  }
}

